import React, { useMemo, useState } from "react";
import MultiSelectDropdown from "../../../Common/MultiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import AssistantUploadDocumentModal from "../../../Model/AssistantUploadDocumentModal";
import ChipsInput from "../../../Common/ChipsInput";
import { emailValidation } from "../../../Common/Validations";
import AddVariableModal from "../../../Model/AddVariableModal";
import AddIcon from "../../../Assets/svgs/AddIcon";
import PlusIconBtn from "../../../Common/PlusIconBtn";
import { setUnsavedChanges } from "../../../Redux/Slice/Common/SelectedTabSlice";
import UploadIcon from "../../../Assets/svgs/UploadIcon";
import ImageIcon from "../../../Assets/svgs/ImageIcon";

const SetUpTab = ({
  isTabSelected,
  formData,
  setFormData,
  formError,
  selectedKnowledgeBaseDocument,
  setSelectedKnowledgeBaseDocument,
  getDocumentsList,
  handleChange,
  userPlanFeatures,
  setFormError,
  assistantId,
  setHasChanged,
  selectedBackground,
  setSelectedBackground,
  showErrorMessage,
  isMetaAssistant,
}) => {
  const dispatch = useDispatch();
  const knowledgeBaseListData = useSelector(
    (state) => state.knowledgeBaseList.knowledgeBaseListData
  );

  const [showUploadDocument, setShowUploadDocument] = useState({
    visible: false,
    data: null,
    isView: false,
  });
  const [addVariableModalVisible, setAddVariableModalVisible] = useState({
    variableFor: null,
    visible: false,
  });

  const formattedKnowledgeBaseDocumentList = useMemo(() => {
    let _formattedDataList = Array.isArray(knowledgeBaseListData?.data)
      ? knowledgeBaseListData?.data?.map((doc) => {
          return { value: doc?.vapiKnowledgeBaseId, label: doc?.name };
        })
      : [];
    return _formattedDataList;
  }, [knowledgeBaseListData, knowledgeBaseListData?.data]);

  const handleChangeKnowledgeBaseListData = (selectedList) => {
    const selectedListIds = Array.isArray(selectedList)
      ? selectedList.map((item) => item?.value)
      : [];
    setSelectedKnowledgeBaseDocument(selectedListIds);
  };

  const onAddDocument = () => {
    setShowUploadDocument({
      visible: true,
      data: null,
      isView: false,
    });
  };

  const onCloseUploadDocument = () => {
    setShowUploadDocument({
      visible: false,
      data: null,
      isView: false,
    });
  };

  const onSuccessUploadDocument = () => {
    onCloseUploadDocument();
    getDocumentsList();
  };

  const handleChangeImage = (e) => {
    const selectedFile = e?.target?.files[0];
    if (!selectedFile) {
      return;
    }

    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(selectedFile.type)) {
      showErrorMessage("Only JPEG, PNG, and GIF images are allowed.");
      return;
    }

    if (selectedFile.size > maxSize) {
      showErrorMessage("File size must be 5MB or less.");
      return;
    }

    setTimeout(() => {
      e.target.value = "";
    }, 300);

    if (e?.target?.files?.length > 0) {
      dispatch(setUnsavedChanges(true));
      setHasChanged(true);
      setSelectedBackground(e.target.files[0]);
      setFormData((p) => ({
        ...p,
        setup: {
          ...p.setup,
          backgroundImage: URL.createObjectURL(e.target.files[0]),
        },
      }));
    }
  };

  const validateEmailInput = (emails) => {
    const isValid = emailValidation(emails);
    if (isValid || emails?.trim() === "") {
      const checkItAlreadyExists = formData?.emailAddress?.find(
        (website) => website === emails
      );
      if (checkItAlreadyExists) {
        setFormError({
          ...formError,
          setupEmailError: "Email already exists.",
        });
      } else {
        setFormError({ ...formError, setupEmailError: "" });
      }
    } else {
      setFormError({
        ...formError,
        setupEmailError: "Please enter valid email",
      });
    }
  };

  const onSubmitAddVariable = (variable) => {
    setFormData((p) => ({
      ...p,
      setup: {
        ...p.setup,
        [addVariableModalVisible.variableFor]:
          typeof p.setup[addVariableModalVisible.variableFor] == "string"
            ? p.setup[addVariableModalVisible.variableFor] + variable
            : p.setup[addVariableModalVisible.variableFor],
      },
    }));
    setAddVariableModalVisible({
      visible: false,
      variableFor: null,
    });
  };

  return (
    <>
      {showUploadDocument.visible ? (
        <AssistantUploadDocumentModal
          visible={showUploadDocument.visible}
          data={showUploadDocument.data}
          isView={showUploadDocument.isView}
          onClose={onSuccessUploadDocument}
          onlyUpload
          onSuccess={onSuccessUploadDocument}
        />
      ) : null}
      {addVariableModalVisible?.visible ? (
        <AddVariableModal
          assistantId={assistantId}
          onSubmit={onSubmitAddVariable}
          onClose={() =>
            setAddVariableModalVisible({
              variableFor: null,
              visible: false,
            })
          }
        />
      ) : null}

      <div
        className={
          isTabSelected
            ? "tabsContent__content tabsContent__content--selected"
            : "tabsContent__content"
        }
      >
        {userPlanFeatures?.KNOWLEDGE_BASE &&
        !isMetaAssistant ? (
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label for="firstMessage" className="form__label">
                  Knowledge Base
                </label>
                {/* <MultiSelectDropdown
                  id="knowledgeBase"
                  name="knowledgeBaseId"
                  options={formattedKnowledgeBaseDocumentList}
                  selectedValue={selectedKnowledgeBaseDocument}
                  onChange={handleChangeKnowledgeBaseListData}
                /> */}
                <select
                  className="form__select form__select--sm"
                  id="knowledgeBase"
                  name="knowledgeBaseId"
                  value={selectedKnowledgeBaseDocument}
                  onChange={(e) =>
                    setSelectedKnowledgeBaseDocument(e?.target?.value)
                  }
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {Array.isArray(formattedKnowledgeBaseDocumentList)
                    ? formattedKnowledgeBaseDocumentList?.map((doc) => (
                        <option value={doc?.value}>{doc?.label}</option>
                      ))
                    : null}
                </select>
              </div>
              {/* <p className="para para--right">
                <button className="link link__primary" onClick={onAddDocument}>
                  +Add Knowledge Base
                </button>
              </p> */}
            </div>
          </div>
        ) : null}
        {!isMetaAssistant ? (
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label for="firstMessage" className="form__label">
                  Assistant Type
                </label>
                <select
                  className="form__select form__select--sm"
                  id="assistantType"
                  name="assistantType"
                  value={formData?.assistantType}
                  onChange={(e) =>
                    setFormData((p) => ({
                      ...p,
                      setup: {
                        ...p?.setup,
                        assistantType: e?.target?.value,
                      },
                    }))
                  }
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                </select>
              </div>
            </div>
          </div>
        ) : null}
        <div className="formRow">
          <div className="formCol">
            <div className="form__Field">
              <label
                for="firstMessage"
                className="form__label form__label--flex"
              >
                <span>
                  First Message<span style={{ color: "red" }}> * </span>
                </span>
                {!isMetaAssistant ? (
                  <PlusIconBtn
                    onClick={() =>
                      setAddVariableModalVisible({
                        variableFor: "firstMessage",
                        visible: true,
                      })
                    }
                  />
                ) : null}
              </label>
              <input
                type="text"
                id="firstMessage"
                maxLength={120}
                className="form__input form__input--sm"
                name="firstMessage"
                onChange={handleChange}
                value={formData?.firstMessage}
                placeholder="First Message"
              />
            </div>
          </div>
        </div>
        <div className="formRow">
          <div className="formCol">
            <div className="form__Field">
              <label
                for="systemPrompt"
                className="form__label form__label--flex"
              >
                <span>
                  Context<span style={{ color: "red" }}> * </span>
                </span>
                {!isMetaAssistant ? (
                  <PlusIconBtn
                    onClick={() =>
                      setAddVariableModalVisible({
                        variableFor: "systemPrompt",
                        visible: true,
                      })
                    }
                  />
                ) : null}
              </label>
              <textarea
                id="systemPrompt"
                name="systemPrompt"
                onChange={handleChange}
                value={formData?.systemPrompt}
                className="form__textarea"
                placeholder="Context"
              ></textarea>
            </div>
          </div>
        </div>

        {userPlanFeatures?.SEND_SUMMARY || isMetaAssistant ? (
          <>
            <div className="formRow">
              <div className="formCol">
                <div className="form__switchBtn form__switchBtn--directionColumn">
                  <div className="form__switchBtn__option">
                    <label for="sendSummary" className="form__label">
                      Send Summary
                    </label>
                    <div className="switchBtn">
                      <input
                        type="checkbox"
                        className="toggle"
                        id="sendSummary"
                        name="sendSummary"
                        checked={formData?.sendSummary}
                        onChange={handleChange}
                      />
                      <label for="sendSummary">
                        <span className="on">ON</span>
                        <span className="off">OFF</span>
                      </label>
                    </div>
                  </div>
                  <div className="form__switchBtn__option">
                    <label for="sendSummaryToContact" className="form__label">
                      Send Summary To Contact
                    </label>
                    <div className="switchBtn">
                      <input
                        type="checkbox"
                        className="toggle"
                        id="sendSummaryToContact"
                        name="sendSummaryToContact"
                        checked={formData?.sendSummaryToContact}
                        onChange={handleChange}
                      />
                      <label for="sendSummaryToContact">
                        <span className="on">ON</span>
                        <span className="off">OFF</span>
                      </label>
                    </div>
                  </div>
                  <div className="form__switchBtn__option">
                    <label for="pdfSummary" className="form__label">
                      Pdf Summary
                    </label>
                    <div className="switchBtn">
                      <input
                        type="checkbox"
                        className="toggle"
                        id="pdfSummary"
                        name="pdfSummary"
                        checked={formData?.pdfSummary}
                        onChange={handleChange}
                      />
                      <label for="pdfSummary">
                        <span className="on">ON</span>
                        <span className="off">OFF</span>
                      </label>
                    </div>
                  </div>
                  <div className="form__switchBtn__option">
                    <label for="sendTranscript" className="form__label">
                      Send Transcript
                    </label>
                    <div className="switchBtn">
                      <input
                        type="checkbox"
                        className="toggle"
                        id="sendTranscript"
                        name="sendTranscript"
                        checked={formData?.sendTranscript}
                        onChange={handleChange}
                      />
                      <label for="sendTranscript">
                        <span className="on">ON</span>
                        <span className="off">OFF</span>
                      </label>
                    </div>
                  </div>
                  {userPlanFeatures?.SEND_SUMMARY || isMetaAssistant ? (
                    <div className="form__switchBtn__option">
                      <label for="sendRecording" className="form__label">
                        Send Recording
                      </label>
                      <div className="switchBtn">
                        <input
                          type="checkbox"
                          className="toggle"
                          id="sendRecording"
                          name="sendRecording"
                          checked={formData?.sendRecording}
                          onChange={handleChange}
                        />
                        <label for="sendRecording">
                          <span className="on">ON</span>
                          <span className="off">OFF</span>
                        </label>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {formData?.sendSummary ||
            formData?.sendSummaryToContact ||
            formData?.pdfSummary ||
            formData?.sendTranscript ||
            formData?.sendRecording ? (
              <>
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="emailNotification" className="form__label">
                        Email Address(es)
                      </label>
                      <div className="form__groupField form__groupField--urlPicker">
                        <div className="urlPickerInfo">
                          <ChipsInput
                            value={formData?.emailAddress}
                            onChange={(data) => {
                              handleChange({
                                target: {
                                  name: "emailAddress",
                                  value: data,
                                },
                              });
                            }}
                            style={{ width: "100%", borderRadius: "0.375rem" }}
                            inputStyle={{ minWidth: "70vw" }}
                            isValid={!formError?.setupEmailError}
                            placeholder="Please enter email address(es) to receive chat summary"
                            validateInput={validateEmailInput}
                          />
                        </div>
                      </div>
                    </div>
                    {formError?.setupEmailError && (
                      <div className="form__error">
                        {formError.setupEmailError}
                      </div>
                    )}
                  </div>
                </div>
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        for="summaryInstructions"
                        className="form__label form__label--flex"
                      >
                        Summary Instructions
                        {!isMetaAssistant ? (
                          <PlusIconBtn
                            onClick={() =>
                              setAddVariableModalVisible({
                                variableFor: "summaryInstructions",
                                visible: true,
                              })
                            }
                          />
                        ) : null}
                      </label>
                      <textarea
                        id="summaryInstructions"
                        name="summaryInstructions"
                        onChange={handleChange}
                        value={formData?.summaryInstructions}
                        className="form__textarea"
                        placeholder="You are skilled in crafting short and clear summaries. Condense the call transcript into 2-3 sentences, if appropriate."
                      ></textarea>
                      <div className="form__error">
                        {formError?.summaryInstructionsError}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="formRow">
              <div className="formCol">
                <div className="form__Field">
                  <label for="WebCallBackground" className="form__label">
                    Web Call Background
                  </label>
                  <div className="form__browsefile__box">
                    <input
                      type="file"
                      id="uploadFile"
                      className="form__uploadfiled"
                      accept="image/*"
                      onChange={handleChangeImage}
                    />
                    <label
                      for="uploadFile"
                      className="form__browsefile form__browsefile--callBackground"
                    >
                      {formData?.backgroundImage ? (
                        <img
                          src={formData?.backgroundImage}
                          style={{
                            width: "100%",
                            maxHeight: "350px",
                          }}
                        />
                      ) : (
                        <>
                          <span className="icon">
                            <ImageIcon />
                          </span>
                          <span className="btn btn__white">
                            <UploadIcon />
                            Upload Background
                          </span>
                        </>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default SetUpTab;
